window.ManageAvailabilityForm = function (scope, nunjucksEngine, enableMinMaxLimits,InterviewViewService, InterviewDataService) {


    var self = this;
    var _protected = BaseForm.call(self, "manage-availability-form", scope);

    //interview duration
    var interview_duration = "15";
    var viewService;
    self.data.interview_duration = "15";
    self.data.interviewSlots = [];
    self.data.errors = {};
    var nunjucksEngine = nunjucksEngine;
    var interviewCalendar;
    var deletedSlots = [];
    var to_interview_duration = null;
    self.enableMinMaxLimits = enableMinMaxLimits;

    //allow overlap
    self.data.interview_overlap = true;

    //bind some actions
    $(document).off('click.interviewDurationOverlay').on('click.interviewDurationOverlay', '.manage-availability-form .overlay', function (event) {
        self.showInterviewDurationMessage();
    });

    /***
     * Load form data
     */
    self.load = function (noRender) {

        var defer = $q.defer();

        //init some vars
        self.data.errors.interview_duration_change = false;
        self.data.errors.reservedSlots = false;
        self.data.errors.reservedSlot = false;

        InterviewAPI.getSlotsEmployer(self.data.job.id, self.data.brandId).then(function (result) {
            //save employer slots
            self.data.interviewSlots = result.slots;

            //save employer slots
            self.data.interview_overlap = result.allow_overlap;

            //if there is no interview slots then don't update deafult interview duration
            if (self.data.interviewSlots && self.data.interviewSlots.length > 0) {
                //if it's there then update it otherwise keep deafult for drwaing the calendar
                // self.data.interview_duration = result.duration;
                if (self.data.interview_duration) {
                    interview_duration = self.data.interview_duration;
                }
            }

            if (!noRender) {
                var slotParts = 60 / interview_duration;
                scope.$digest();

                //set start date to job published date
                var startDate = moment(new Date());
                var timezone = startDate.zone();
                startDate.set('minute', 0);
                startDate.set('second', 0);
                startDate.set('millisecond', 0);
                startDate.day(0);
                startDate.zone(timezone);
                startDate.set('hour', InterviewCalendar.hourStart);
                var minNavDate = moment(self.data.job.publish_date);

                //max nav date
                var maxNavDate = startDate.clone();
                maxNavDate = maxNavDate.add(InterviewCalendar.interviewWeekRange, 'weeks');

                //Render the calendar
                renderCalendar(startDate, slotParts, self.data.interviewSlots, minNavDate, maxNavDate);
            }

            defer.resolve(result);

        });

        return defer.promise;
    };

    var resetDateHours = function (date, startOfWeek) {
        var timezone = date.zone();
        date.set('minute', 0);
        date.set('second', 0);
        date.set('millisecond', 0);
        if (startOfWeek) {
            date.day(0);
        }
        date.zone(timezone);
        date.set('hour', InterviewCalendar.hourStart);
        return date;
    };

    var redrawCalendarWithUpdatedSettings = function (duration) {
        var publishDate = (self.job && self.job.publish_date && !self.job.isTemplate)? moment(self.job.publish_date): moment();
        var endDate = self.job && self.job.end_date? moment(self.job.end_date): publishDate.clone().add(30, "days");

        if (self.job.end_date) {
            endDate = moment(self.job.end_date);
        }
        else {
            var jobMaxTime = 30;

            if (self.job.life_time && self.job.life_time.max_life_time) {
                jobMaxTime = self.job.life_time.max_life_time;
            }

            endDate = publishDate.clone().add(jobMaxTime, "days");
        }

        var interviewSettings = self.job.interview_settings || {};
        var interviewWindow = interviewSettings.interview_window || 365;
        var interviewRecession = interviewSettings.interview_recession_period || 1;

        interview_duration = String(duration || interviewSettings.interview_slot || interview_duration);
        // self.data.interview_duration = interview_duration;

        var startDate = endDate.clone().add(interviewRecession, 'days');
        var minNavDate = endDate.clone().add(interviewRecession, 'days');
        var maxNavDate = minNavDate.clone().add(interviewWindow, 'days');

        renderCalendar(resetDateHours(startDate, true), (60 / interview_duration), self.data.interviewSlots, resetDateHours(minNavDate), resetDateHours(maxNavDate));
        scope.$evalAsync();
    };

    self.updateMinMax = function (publishDate, endDate) {
        self.job.publish_date = publishDate;
        self.job.end_date = endDate;
        redrawCalendarWithUpdatedSettings();
    };

    self.loadJobId = function (jobId) {
        self.data.job = self.data.job || {};
        self.data.job.id = jobId;
        self.job.id = jobId;
    };

    self.loadJob = function (job) {

        InterviewDataService.parseData(moment().startOf('week'), {});
        viewService = InterviewViewService({});
        viewService.stepSize = parseInt(self.data.interview_duration);
        viewService.doNotSplit = true;
        viewService.init(moment().startOf('week'));

        self.job = $.extend({}, job);
        self.data.brandId = job.Brand && job.Brand.id;
        self.data.job = {
            id: job && job.id
        };

        if (self.data.job.id && !self.job.isTemplate) {
            self.load(true)
                .then(function () {
                    redrawCalendarWithUpdatedSettings();
                });
        }
        else {
            redrawCalendarWithUpdatedSettings();
        }


        BrandAPI.getBrandInterviewers(self.data.brandId, true)
            .then(function (data) {
                self.interviewersList = data.users.map(function (user) {
                    return {
                        name: user.first_name + ' ' + user.last_name,
                        id: user.id
                    }
                });
                setTimeout(function () {
                    viewService.drawAll();
                }, 1000);
                scope.$digest();
            });
    };

    self.validator.validateCustom = function (field, optionsField, rule, showError) {
        var value = self.validator.getFieldValue(field);
        delete self.data.errors.timeSlot;

        switch (rule.name) {
            case 'is-slots-available':
                var valid = self.isOptional || validAvailability(self.data.interviewSlots, self.data.interview_overlap);
                if (!valid) {
                    self.data.errors.timeSlot = true;
                    return false;
                }

                break;
        }
        return true;
    };

    /**
     *
     * Save form data
     * @returns {*}
     */
    self.save = function () {
        var defer = $q.defer();

        var submitBtn = $('.manage-availability-form').find('#submit-btn');
        submitBtn.button('loading');
        if (self.validator.validate()) {

            //validate time slots
            if (!validAvailability()) {
                if (self.isOptional) {
                    defer.resolve({});
                }
                else {
                    self.data.errors.timeSlot = true;
                    submitBtn.button('reset');
                    defer.reject({code: "validation", message: "No Interview Slots"});
                }
            }
            else {
                //before save
                var formData = {};
                //loop all slots and convert them to UTC
                var slotsSent = [];

                for (var i in InterviewDataService.flatData.slots) {
                    slotsSent.push({
                        from_time: moment.utc(InterviewDataService.flatData.slots[i].start_time),
                        to_time: moment.utc(InterviewDataService.flatData.slots[i].end_time)
                    });
                }
                console.log("se", self.job)

                var payload = {
                    type: 'AQAAF',
                    job_id: self.data.job.id,
                    allow_overlap: !!self.data.interview_overlap,
                    duration: (parseInt(self.data.interview_duration) * 60),
                    title: "",
                    interviewers: _.map(self.data.interviewers, function (value) {
                        return { user_id: value.id };
                    }),
                    location: self.data.selected_location,
                    slots: slotsSent,
                    applications: [],
                    message: {
                        message: ""
                    }
                };

                InterviewV2API.saveBrandInterviewSet(self.data.brandId.id, payload)
                    .then(function (response) {
                        console.log("response", response)
                        defer.resolve();
                            submitBtn.button('reset');
                            defer.resolve(response);
                    }, function (error) {
                        console.error(error);
                        submitBtn.button('reset');
                        // defer.reject(errors);
                        defer.resolve({});
                    });

                // var setSlots = InterviewAPI.setSlots(self.data.job.id,
                //     self.data.brandId,
                //     null,
                //     slotsSent,
                //     parseInt(interview_duration),
                //     self.data.interview_overlap);
                //
                // setSlots.then(function (res) {
                //     if (self.data.cards) {
                //         res.cards = self.data.cards;
                //     }
                //     submitBtn.button('reset');
                //     defer.resolve(res);
                // }, function (errors) {
                //     submitBtn.button('reset');
                //     defer.reject(errors);
                // });
            }
            //end before save
        }
        else {
            submitBtn.button('reset');
            defer.reject("Form didn't validate");
        }

        return defer.promise;
    };

    self.weekStartDate = moment().startOf('week');
    self.weeklyRange = {
        from: self.weekStartDate.clone(),
        to: self.weekStartDate.clone().add(6, 'd')
    };

    scope.onInterviewersChanged = function ($event) {
        // var interviewers = $event.val;
        // if (interviewers.length > 0) {
        //     // load interviewers' available and booked slots
        //     var availableSlotsPromise = InterviewV2API.getJobInterviewersAvailabilities(
        //         self.data.brandId,
        //         self.data.job.id,
        //         interviewers,
        //         self.weeklyRange.from,
        //         moment(self.weeklyRange.to).add('d', 1),
        //         "AVAILABLE"
        //     );
        //
        //     var bookedSlotsPromise = InterviewV2API.getJobInterviewersAvailabilities(
        //         self.data.brandId,
        //         self.data.job.id,
        //         interviewers,
        //         self.weeklyRange.from,
        //         moment(self.weeklyRange.to).add('d', 1),
        //         "BOOKED"
        //     );
        //
        //     var availabilityPromises = {available: availableSlotsPromise, booked: bookedSlotsPromise};
        //
        //     $q.all(availabilityPromises)
        //         .then(function (response) {
        //             var availableSlots = response.available.interviewers;
        //             var bookedSlots = response.booked.interviewers;
        //
        //             InterviewDataService.resetAvailabilities();
        //             InterviewDataService.parseAvailabilities(bookedSlots, "BOOKED", interviewers.length);
        //             InterviewDataService.parseAvailabilities(availableSlots, "AVAILABLE", interviewers.length);
        //             // viewService.init(self.weekStartDate);
        //             // viewService.drawGridAvailabilities();
        //             viewService.drawAll();
        //
        //             scope.$digest();
        //
        //         }, function (err) {
        //             console.error(err);
        //             scope.$digest();
        //         });
        // }
        // else {
        //     InterviewDataService.resetAvailabilities();
        //     viewService.clearGridAvailabilities();
        // }
    };


    /***
     *
     * validate availability
     *
     * check if any slot is in future and (it's not reserved  || (reserved && overlap is on))
     */
    var validAvailability = function () {

        var isEmpty = true;
        for (var i in viewService.viewData.schedule.columns) {
            var column = viewService.viewData.schedule.columns[i];
            if (column.slots.length) {
                isEmpty = false;
                break;
            }
        }

        // return true for valid availability
        return !isEmpty;
    };

    /**
     * validate if the user can change interview duration or not
     */
    var canChangeDuration = function (slots) {
        var todayDate = new Date();

        for (var i in slots) {

            //if the start time of any slot is greater than now - you can't change duration
            if (slots[i].start_time.getTime() > todayDate.getTime()) {
                return false;
            }
        }

        return true;
    };

    var renderCheck = null;

    var renderCalendar = function (startDate, slotParts, employerSlots, minNavDate, maxNavDate) {

        clearInterval(renderCheck);
        renderCheck = setInterval(function () {

            if (self.formViewLoaded) {

                setTimeout(function () {
                    // viewService.drawAll();
                    scope.$digest();
                }, 1000);

                clearInterval(renderCheck);
                /*interviewCalendar = new InterviewCalendar(nunjucksEngine, {
                    type: 'schedule',
                    elementSelector: '.manage-availability-form #interview-calendar',
                    startDate: startDate,
                    minNavDateTime: minNavDate,
                    maxNavDateTime: maxNavDate,
                    selectionType: 'selectable',
                    employerSlots: employerSlots,
                    slotParts: slotParts,
                    applyCustomScroller: true,
                    enableMinMaxLimits: enableMinMaxLimits,
                    onSlotChanged: function (slot) {

                        //find if it's already there
                        var slotIndex = findSlotIndex(slot, self.data.interviewSlots);

                        //push it or remove
                        if (slotIndex > -1) {
                            var removedSlot = ar_delete(self.data.interviewSlots, slotIndex);
                            if (removedSlot.reserved_by) {
                                deletedSlots.push(removedSlot);
                            }
                        } else {

                            self.data.errors.timeSlot = false;
                            scope.$digest();

                            var slotData = {};

                            //find if the new slot is in deleted slots
                            var slotIndex = findSlotIndex(slot, deletedSlots);
                            if (slotIndex > -1) {
                                slotData = ar_delete(deletedSlots, slotIndex);
                            } else {
                                //convert to utc before sending to API
                                slotData.start_time = new Date(parseInt(slot.start_time));
                                slotData.end_time = new Date(parseInt(slot.end_time));
                                slotData.id = slot.id;
                            }
                            //push slot to interview slots
                            self.data.interviewSlots.push(slotData);
                        }

                    }
                });*/
            }

        }, 300);
    };


    /***
     * find slot index in array
     *
     * @param slot
     * @param arr
     */
    var findSlotIndex = function (slot, arr) {

        var slotIndex = -1;
        for (var i in arr) {
            if (arr[i].start_time.getTime() == new Date(slot.start_time).getTime()) {
                slotIndex = i;
                break;
            }
        }

        return slotIndex;
    }

    self.setIsOptional = function (isOptional) {
        self.isOptional = isOptional;

        if (isOptional) {
            self.data.errors = {};
        }
    };

    self.cancelChangeDuration = function () {
        self.data.errors.interview_duration_change = false;
    }

    self.confirmChangeDuration = function () {
        self.resetComingSlots();
        self.updateInterviewDuration();
    }

    self.resetComingSlots = function () {

        self.data.errors.interview_duration_change = false;

        self.reservedSlots = [];

        if (interviewCalendar) {
            var indicesToDelete = [];
            var now = moment();
            for (var i = self.data.interviewSlots.length - 1; i >= 0; i--) {
                var slot = self.data.interviewSlots[i];

                if (slot.reserved_by) {
                    self.reservedSlots = self.reservedSlots.concat(slot.reserved_by);
                }
                if (now.isBefore(slot.start_time)) {
                    indicesToDelete.push(i);
                }
            }

            for (var i in indicesToDelete) {
                ar_delete(self.data.interviewSlots, indicesToDelete[i]);
            }

            interviewCalendar.renderCalendar();
        }
        if (to_interview_duration) {
            self.data.interview_duration = to_interview_duration;
        }

        self.data.errors.reservedSlots = self.reservedSlots.length > 1;
        self.data.errors.reservedSlot = self.reservedSlots.length === 1;
    }

    /***
     *
     * Update Interview Duration
     */
    self.updateInterviewDuration = function (isCustom) {

        to_interview_duration = null;

        //inside timeout to solve IE latency issue
        //HARRI-6204


        setTimeout(function () {
            interview_duration = self.data.interview_duration;
            if (isCustom || self.data.interview_duration == 'CUSTOM') {
                interview_duration = parseInt(self.data.custom_duration_hours) + parseInt(self.data.custom_duration_minutes);
            } else {
                interview_duration = parseInt(self.data.interview_duration);
                self.data.custom_duration_hours = String(parseInt(parseInt(interview_duration) / 60) * 60);
                self.data.custom_duration_minutes = String(parseInt(interview_duration) % 60);
            }

            viewService.clearSlots();
            viewService.stepSize = parseInt(interview_duration);
            viewService.init(moment().startOf('week'));
            viewService.drawAll();
            return;
            //if cannot change duration, revert and block
            if (!canChangeDuration(self.data.interviewSlots)) {
                //save to duration till confirm or cancel
                to_interview_duration = self.data.interview_duration;
                //reset value
                self.data.interview_duration = interview_duration;
                //show error
                self.data.errors.interview_duration_change = true;
                //apply digest
                scope.$digest();

                return;
            }

            //update on success update duration
            self.data.errors.interview_duration_change = false;

            deletedSlots = [];

            //save it for later use
            interview_duration = self.data.interview_duration;

            if (!self.enableMinMaxLimits) {
                //find slot parts
                var slotParts = 60 / interview_duration;
                //set start date to job published date
                var startDate = moment();
                startDate = startDate.startOf('week');
                startDate.set('hour', InterviewCalendar.hourStart);

                var minNavDate = moment(self.data.job.publish_date);
                //max nav date
                var maxNavDate = startDate.clone();
                maxNavDate = maxNavDate.add(InterviewCalendar.interviewWeekRange, 'weeks');

                renderCalendar(startDate, slotParts, self.data.interviewSlots, minNavDate, maxNavDate);
            }
            else {
                redrawCalendarWithUpdatedSettings(interview_duration);
            }


        }, 1);
    }

    /***
     * show interview duraction action messgae
     *
     */
    self.showInterviewDurationMessage = function () {
        $('.manage-availability-form .interview-duration-action-msg').fadeIn();
        $button = $(".manage-availability-form .interview_duration");
        $button
            .stop()
            .animate({'right': '10px'}, 20)
            .animate({'right': '2px'}, 40)
            .animate({'right': '10px'}, 40)
            .animate({'right': '2px'}, 40)
            .animate({'right': '10px'}, 40)
            .animate({'right': '2px'}, 40)
            .animate({'right': '10px'}, 40)
            .animate({'right': '0'}, 20);

        setTimeout(function () {
            $('.manage-availability-form .interview-duration-action-msg').fadeOut();
        }, 4000);
    }

    /***
     * set brand id
     *
     * @param brandId
     */
    self.setBrandId = function (brandId) {
        self.data.brandId = brandId;
    }

    /***
     * set Job
     *
     * @param job
     */
    self.setJob = function (job) {
        self.data.job = job;
    }


    /****
     * set User
     *
     * @param user
     */
    self.setUser = function (user) {
        self.data.user = user;
    }

    /****
     *
     * set saved callback
     *
     * @param onSavedCallback
     */
    self.setOnSavedCallback = function (onSavedCallback) {
        self.onSavedCallback = onSavedCallback;
    }

    /****
     *
     * set Cards
     *
     */
    self.setCards = function (cards) {
        self.data.cards = cards;
    }

};